export const REGEX = {
	BIC_REGEX: /^[A-z0-9]{8}$/,
	EMAIL_REGEX: /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-z0-9-]+\.)+[A-z]{2,12}$/,
	IBAN_REGEX: /^[A-z]{2}[A-z0-9]{14}$/,
	PHONE_REGEX: /^(\+)?[0-9]{9,15}$/,
	UUID_REGEX: /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/,
};
